import { Box } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";

const width = 360;
const overlap = 230;
const useScriptStyles = makeStyles(theme => ({
    comments: {
        position: "absolute",
        top: theme.spacing(6),
        right: -width + overlap,
        width,
        zIndex: 10
    }
}));

interface IProps {
    comments: (HTMLDivElement | null) []
    states: string[]
}
export default function CommentsBox({comments, states}: IProps) {
    const classes = useScriptStyles();

    return (
        <Box className={classes.comments}>
            {states.map((state, index) =>
                {
                    return <div key={state} ref={el => comments[index] = el}> </div>
                }).filter((value) => { return value !== null })}
        </Box>
    );
}